import { Menu } from 'antd';
import React, { useState, useEffect } from 'react';
import styles from '../../../../commons/styles';
// import { constant } from '../../../Settings/Constants';
import {
  SettingOutlined,
  GlobalOutlined,
  MonitorOutlined,
  // UserOutlined,
  DatabaseOutlined
} from '@ant-design/icons';
// import {
//   Settings,
//   SystemParameter,
//   ZeroAdjust,
//   Memory,
//   Calibration,
//   Correction,
//   ChannelParameter,
//   ContinuousMeasurement,
//   SingleMeasurement,
//   Measurement
// } from '../MoistureSensor/form';
import { useNavigate } from 'react-router-dom';
import MoistureSensorRouter from '../../../../routes/moistureSensorRouter';

// const { SubMenu } = Menu;
const { StyledWrapper, StyledWrapperLeft, StyledWrapperRight } = styles.layout;

const MoistureSensor = (props) => {
  const [formName, setFormName] = useState('');
  const [deviceId, setDeviceId] = useState('');
  const collapsed = useState(true);
  // const [translationCache, setTranslationCache] = useState(props.translationCache || {});
  const navigate = useNavigate();

  useEffect(() => {
    const initialFormName = props.match.params.formName;
    const initialDeviceId = props.match.params.deviceId;
    setFormName(initialFormName);
    setDeviceId(initialDeviceId);
    
  }, [
    props.match.params.formName, props.match.params.deviceId
  ]);

  useEffect(() => {
    if (
      props.match.params.formName !== formName ||
      props.match.params.deviceId !== deviceId
    ) {
      setFormName(props.match.params.formName);
      setDeviceId(props.match.params.deviceId);
    }
  }, [props.match.params.formName, props.match.params.deviceId, formName, deviceId]);

  const translation = (keyword) => {
    return props.translationCache && props.translationCache[keyword] ? props.translationCache[keyword] : keyword;
  };

  const redirectPage = (path) => {
    return `/rubus/form/MoistureSensor1/${path}`;
  };

  function getItem(label, key, icon, children, type) {
    return {
      key,
      icon,
      children,
      label,
      type
    };
  }
  const items = [
    getItem(
      translation('Measurement'),
      redirectPage('Measurement'),
      <GlobalOutlined />
    ),
    getItem(
      translation('Calibration Curve'),
      redirectPage('CalibrationCurve'),
      <MonitorOutlined />,
      [
        getItem(translation('Calibration'), redirectPage('Calibration')),
        getItem(translation('Correction'), redirectPage('Correction')),
        getItem(translation('Channel Parameter'), redirectPage('ChannelParameter'))
      ]
    ),
    getItem(
      translation('Maintenance'),
      redirectPage('Maintenance'),
      <DatabaseOutlined />,
      [
        getItem(translation('System Parameter'), redirectPage('SystemParameter')),
        getItem(translation('Memory'), redirectPage('Memory')),
        getItem(translation('Zero Adjust'), redirectPage('ZeroAdjust'))
      ]
    ),
    getItem(translation('Settings'), redirectPage('Settings'), <SettingOutlined />)
  ];

  return (
    <StyledWrapper style={{ minHeight: window.innerHeight - 140 }}>
      <StyledWrapperLeft>
        <Menu
          mode="inline"
          defaultSelectedKeys={[collapsed]}
          style={{ height: '100%' }}
          items={items}
          onClick={(e) => {
            navigate(e.key);
          }}
        />
      </StyledWrapperLeft>
      <StyledWrapperRight style={{ margin: '1px 15px 13px 15px' }}>
        <MoistureSensorRouter />
      </StyledWrapperRight>
    </StyledWrapper>
  );
};

export default MoistureSensor;
